<script lang="ts">
    import { mdiMinusCircleOutline, mdiPlusCircleOutline } from "@mdi/js"
    import Icon from "../../../widgets/Icon.svelte"
    import { createEventDispatcher } from "svelte"
    const dispatch = createEventDispatcher()
    export let quantity = 1
</script>

<div class="quantity">
    <button
        on:click="{() => {
            quantity = Math.max(1, quantity - 1)
            dispatch('updateQuantity', { quantity })
        }}"><Icon path="{mdiMinusCircleOutline}" /></button
    >
    <div class="wrapper">
        <small> {quantity}</small>
    </div>
    <button
        on:click="{() => {
            quantity = Math.max(1, quantity + 1)
            dispatch('updateQuantity', { quantity })
        }}"><Icon path="{mdiPlusCircleOutline}" /></button
    >
</div>

<style lang="less">
    .quantity {
        display: flex;
        flex-direction: row;
        gap: 6px;
        .wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 25px;
            padding: 0px;
            margin: 0px;
            small {
                height: fit-content;
                border-bottom: 1px solid var(--bg-200);
                width: 100%;
                display: flex;
                padding-bottom: 6px;
                padding-top: 6px;
                justify-content: center;
            }
        }
        button {
            color: var(--text-invers-100);
        }
    }
</style>
